// extracted by mini-css-extract-plugin
module.exports = {"buttons":"e70df01526d533b01e94152d4ff30000"};